import { FiltersContextProps } from '@interfaces/Contexts';
import React from 'react';

export const FiltersContext = React.createContext<FiltersContextProps>(
  {} as FiltersContextProps,
);
